<template>
  <a-modal
      :visible="visible"
      :maskClosable="false"
      title="公告"
      :width="600"
      @cancel="close"
      :close-icon="false"
      wrap-class-name="antd-reset-modal"
      class="protocol">

    <template #footer>
      <a-space>
        <a-button type="primary" @click="close">
          确认
        </a-button>
      </a-space>
    </template>

    <div class="container" v-html="$sys().gonggao">

    </div>
  </a-modal>
</template>

<script setup>
//组件属性
defineProps({
  visible: {
    required: false,
    default: false
  }
});

/* 自定义事件 */
const emit = defineEmits(['update:visible']); //自定义事件

/* 关闭 */
const close = () => {
  emit('update:visible', false);
}
</script>

<style lang="scss" scoped>

.container {
  box-sizing: border-box;
  width: 100%;
  max-height: 50vh;
  padding: 20px 36px;
  overflow: hidden;
  overflow-y: auto;
  line-height: 1.8;
  @include scroll-bar();
  font-size: $font-size-2;

  b {
    display: inline-block;
    width: 100%;
    text-align: center;
    font-size: $font-size;
  }

}

.between {
  display: flex;
  justify-content: space-between;
  width: 100%;

}


.checkbox {
  display: flex;
}

</style>
